import PlanCard from "./PlanCard";
import {useQuery} from "@tanstack/react-query";
import {getPlans} from "../../api/api";
import handleUnauthorized401QueryError from "../../utils/handleUnauthorized401QueryError";
import {toast} from "react-toastify";
import {useContext} from "react";
import AuthContext from "../../context/AuthContext";
import Loader from "../../components/Loader";
import RecordsNotFound from "../../components/RecordsNotFound";


function PlansPage(props) {


    const {refreshToken} = useContext(AuthContext)
    const { status, data, error, refetch } = useQuery({
        queryKey: ['plans'],
        queryFn: () => getPlans(),
        keepPreviousData : true,
        retry: false,
        onError: (err => {
            handleUnauthorized401QueryError(err, refreshToken, refetch)
            if(err.response.status !== 401){
                toast.error(`An error occurred! ${err?.response?.data?.detail}`)
            }
        })
    })

    return (
        <>
            <div className="row my-3">

                {status === 'loading' && (
                    <Loader size={'default'}/>
                )}

                {status === 'success' | error?.response?.status === 401 && (
                    data?.count > 0? data?.results?.map(plan => (
                    <PlanCard plan={plan}/>
                    )): <RecordsNotFound/>
                )}

            </div>
        </>
    );
}

export default PlansPage;